<div class="c-portlet o-block u-width-100p _u-width-100p u-shadow-mini u-bg-primary c-portlet_box_specs display-lift-v3-container">
  <div class="cards-holder">
    <div class="card card2 mRight" #chartcontainer>
      <app-loader [showLoader]=showLoad></app-loader>
      <div class="c-portlet__header">
        <div class="o-stack__cell">
          <h5 class="creative-charts-header card-title">SEM Ads</h5>
          <span *ngIf="tableConfig.enableDownload && hasData" class="datatable-icon">
            <a href="javascript:void(0)" class="datatable_download_icon" (click)="downloadCSV()" target="_blank">
              <i class="fa fa-download" aria-hidden="true"></i>
            </a>
          </span>
        </div>
      </div>
      <div class="performance-graph-area">
        <select (change)="updateCreative($event.target.value)">
          <option *ngFor="let creative of creatives; let index = index" [value]="index">{{creative.ad_headline}}</option>
        </select>
        <div class="card3 creative-div">
          <app-loader [showLoader]=showLoad></app-loader>
          <div class="c-portlet__content u-pt-small">
              <div class="analytics-portlet-content sem-creative-card-container">
                <div *ngIf="currentCreative && hasData">
                  <div class="sem-creative-card" [ngStyle]="{'padding-top': dotsHeight?dotsHeight:''}">
                    <div class="sem-creative-heading">{{currentCreative.ad_headline}}</div>
                    <div class="sem-creative-card-link-container">
                      <span class="sem-creative-card-text">AD</span>
                      <cite class="sem-creative-card-link">{{currentCreative.url}}</cite>
                    </div>
                    <span class="sem-creative-card-roboto"> {{currentCreative.callExtension}}</span>
                    <div *ngIf="isTypeString(currentCreative?.description); else elseBlock" class="sem-creative-card-description sem-creative-card-roboto">
                      {{currentCreative?.description}}
                  </div>
                  <ng-template #elseBlock>
                      <div class="sem-creative-card-description sem-creative-card-roboto">
                          <p *ngFor="let desc of currentCreative?.description">
                            {{desc}}
                          </p>
                      </div>
                  </ng-template>
                    
                    <div class="sem-creative-card-callouts-container sem-creative-card-roboto">
                      <div>
                        <p>
                          <span *ngFor="let callout of currentCreative?.calloutsExtn; let i=index">{{callout}}<span [ngClass]="{'last_callout_class': i==currentCreative?.calloutsExtn.length-1}">  &middot; </span></span>
                        </p>
                      </div>
                    </div>
                      <div class="sem-creative-card-structuredsnippets-container sem-creative-card-roboto">
                        <div *ngFor="let snippet of currentCreative?.structuredSnippetExtn">
                          <p>{{snippet?.type}}: {{snippet?.value}}</p>
                        </div>
                      </div>
                    <div class="sem-creative-card-siteLinks-container">
                      <div *ngFor="let siteLink of currentCreative.siteLinks;" class="sem-creative-card-sitelinks">
                        <h4>
                          <a href="{{siteLink.link}}" target="_blank">{{siteLink.heading}}</a>
                        </h4>
                        <span class="sem-creative-card-roboto">{{siteLink.description}}</span>
                      </div>
                    </div>
                    <div *ngIf="currentCreative && currentCreative.location && currentCreative.location.trim().split(',').length>0">
                      <span [ngStyle]="{'color' :  !last ?  '#1a0dab' : '#4a4a4a'}" *ngFor="let location of currentCreative.location.split(','); let last = last; let first = first;" class="sem-creative-card-location" >
                        <i class="fa fa-map-marker" aria-hidden="true" *ngIf="first" style="color: #575757;"></i> {{location}}<span *ngIf="!last">,</span></span>
                    </div>
                  </div>
                  <div class="text-table">
                    <ul class="creative-stats">
                      <li>
                        <span class="stats">{{currentCreative.impressions | number}}</span>
                        <span class="stats-label">Impressions</span>
                      </li>
                      <li>
                        <span class="stats">{{currentCreative.clicks | number}}</span>
                        <span class="stats-label">Clicks</span>
                      </li>
                      <li>
                        <span class="stats">{{currentCreative.clickthroughrate | number}}%</span>
                        <span class="stats-label">CTR</span>
                      </li>
                      <li *ngIf="!isGoliveNotStarted">
                          <span class="stats">{{currentCreative.absTopImpressionShare | number}}%</span>
                          <span class="stats-label">Abs. Top Imp.</span>
                        </li>
                        <li *ngIf="!isGoliveNotStarted">
                          <span class="stats">{{currentCreative.topImpressionShare | number}}%</span>
                          <span class="stats-label">Top Imp.</span>
                        </li>
                      <li *ngIf="!isCutoffDate">
                        <span class="stats">{{currentCreative.avg_position? (currentCreative.avg_position | number): '--'}}</span>
                        <span class="stats-label">Avg. Position</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          <div class="no-data-container" *ngIf="!hasData">
            <div class="map-no-data">No Data to Display</div>
          </div>
          <!-- </div> -->
        </div>
      </div>
    </div>
    <div class="card card1 right-card">
      <app-loader [showLoader]=showLoad></app-loader>
      <div class="c-portlet__header r4-c-portlet__header">
        <div class="o-stack__cell">
          <div class="title-div">
              <div class="ads-title">Top 5 SEM Ads</div>
              <div class="performance-graph-area ads-select">
                  <select (change)="updateAds($event.target.value)">
                    <option *ngFor="let ads of topAdsFields.columns| slice:1; let index = index" [value]="ads.columnKey">{{ads.columnName}}</option>
                  </select>
                </div>
          </div>
          <div class="ads-div">
            <div class="preRoll-creative-completion-stats-scroll-div" *ngFor="let ad of currentAd| slice:0:5;let index = index">
                <div class="preRoll-creative-completion-stats">
                    <div class="progressbar">
                      <div class="primary-color-bg bar" [ngStyle]="getBarPercentage(ad.value)"></div>
                    </div>
                    <div class="preRoll-creative-views  par-title-font add-color">
                      <div class="par-title">{{(ad.title.length>55)? (ad.title | slice:0:55)+'...':(ad.title)}}</div>
                      <div class="par-val primary-color">{{ad.value}} <span *ngIf="ad?.type === 'clickthroughrate' || ad?.type === 'top_impression_share' || ad?.type === 'abs_top_impression_share'">%</span> {{ad.name}}</div>
                    </div>
                  </div>
            </div>
          </div>
        </div>
        
      </div>
      <div class="no-data-container" *ngIf="!hasData">
        <div class="map-no-data">No Data to Display</div>
      </div>
    </div>
  </div>
</div>
